import { DESK_OWNER_IDENTITY, DEFAULT_PROVIDER, } from 'modules/application/detail/attendance/configuration/ConfigurationController';
import { SUCCESS_STATUS, FAILURE_STATUS } from 'modules/application/misc/SegmentService';
import * as styles from './deskwebhook.module.scss';
import { ToastType } from 'modules/application/misc/ToastService';
import { AttendanceFeatures } from 'modules/application/detail/attendance/AttendanceFeatures';
export const Webhook = 'Webhook';
export class WebhookController {
    static $inject = ['application', 'LoadingService', 'ConfigurationsService', 'DeskConfigurationService', 'ToastService', 'SegmentService', 'MESSAGINGHUBDOMAIN'];
    constructor(application, LoadingService, ConfigurationsService, DeskConfigurationService, ToastService, SegmentService, MESSAGINGHUBDOMAIN) {
        this.application = application;
        this.LoadingService = LoadingService;
        this.ConfigurationsService = ConfigurationsService;
        this.DeskConfigurationService = DeskConfigurationService;
        this.ToastService = ToastService;
        this.SegmentService = SegmentService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
    }
    async $onInit() {
        await this.checkFeatures();
        this.styles = styles;
        this.loadConfiguration();
    }
    async checkFeatures() {
        this.isConfigurationsApplicationsDomainUsageGetEnabled = await AttendanceFeatures.isUseConfigurationsDomainOnAttendanceOperationsGetEnabled();
        this.isConfigurationsApplicationsDomainUsageSetEnabled = await AttendanceFeatures.isUseConfigurationsDomainOnAttendanceOperationsSetEnabled();
    }
    /**
     * Load bot's customer service channel configuration
     */
    async loadConfiguration() {
        try {
            this.LoadingService.startLoading();
            const configuration = await this.ConfigurationsService.get(`${DESK_OWNER_IDENTITY}.${this.MESSAGINGHUBDOMAIN}`, undefined, this.isConfigurationsApplicationsDomainUsageGetEnabled);
            this.configuration = { ...configuration };
            this.isActive =
                this.configuration
                    && this.configuration[DEFAULT_PROVIDER] === Webhook;
            this.hasBlipTeams =
                this.configuration['Webhook.HasBlipTeams'] &&
                    this.configuration['Webhook.HasBlipTeams'].toLowerCase() === 'true';
            if (this.configuration['Webhook.BlipTeams']) {
                this.blipTeams = this.configuration['Webhook.BlipTeams'].split(',');
            }
            else {
                this.blipTeams = [''];
            }
        }
        catch (e) {
            if (e.code !== 67) {
                this.ToastService.toast(ToastType.Danger, 'deskWebhookProvider.error.loadConfiguration');
            }
            else {
                this.configuration = {};
                this.isActive = false;
                this.hasBlipTeams = false;
                this.blipTeams = [''];
            }
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    /**
     * Check if another customer service channel is connected
     *
     * @returns whether a channel other than Webhook is connected or not
     */
    isOtherChannelConnected() {
        return this.configuration
            && this.configuration[DEFAULT_PROVIDER]
            && this.configuration[DEFAULT_PROVIDER] !== Webhook;
    }
    /**
     * Submit Configuration tab form
     */
    submitConfigurationForm() {
        if (this.isOtherChannelConnected()) {
            this.ToastService.toast(ToastType.Danger, 'deskWebhookProvider.error.concurrence');
            return;
        }
        this.configuration['Webhook.HasBlipTeams'] = this.hasBlipTeams;
        const validTeams = this.blipTeams?.filter(t => t);
        if (this.hasBlipTeams && validTeams.length > 0) {
            this.configuration['Webhook.BlipTeams'] = validTeams.join(',');
        }
        else if (this.hasBlipTeams) {
            this.configurationForm.$invalid = true;
            this.ToastService.toast(ToastType.Danger, 'deskWebhookProvider.error.noTeams');
            return;
        }
        this.activateIntegration();
    }
    /**
     * If no other channel is connected, save configuration and activates Webhook
     */
    async activateIntegration() {
        if (this.isOtherChannelConnected()) {
            this.isActive = false;
            this.ToastService.toast(ToastType.Danger, 'deskWebhookProvider.error.concurrence');
            return;
        }
        if (this.configurationForm.$invalid) {
            this.ToastService.toast(ToastType.Danger, 'deskWebhookProvider.error.noConfiguration');
            return;
        }
        try {
            this.LoadingService.startLoading();
            this.configuration[DEFAULT_PROVIDER] = Webhook;
            await this.saveConfiguration();
            this.isActive = true;
            this.setBlockToolsCache(true);
            this.registerSuccessfulConnection();
        }
        catch (e) {
            this.isActive = false;
            this.registerFailedConnection();
        }
        finally {
            this.configurationForm.$setPristine();
            this.LoadingService.stopLoading();
        }
    }
    /**
     * Delete configuration default customer service channel
     */
    async deleteIntegration() {
        try {
            this.LoadingService.startLoading();
            await this.deleteConfiguration();
            this.isActive = false;
            this.setBlockToolsCache(false);
            this.registerSuccessfulDisconnection();
        }
        catch (e) {
            this.isActive = true;
            this.registerFailedDisconnection();
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    /**
     * Delete configuration's default provider
     */
    async deleteConfiguration() {
        await this.ConfigurationsService.deleteSingle(`${DESK_OWNER_IDENTITY}.${this.MESSAGINGHUBDOMAIN}`, DEFAULT_PROVIDER, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
    }
    /**
     * Set shouldBlockTools' cache value
     *
     * @param value - new boolean value for cache
     */
    async setBlockToolsCache(value) {
        try {
            await this.DeskConfigurationService.setBlockToolsCache(this.application, value);
        }
        catch (e) { }
    }
    /**
     * On switch trigger, activate or delete Webhook integration
     *
     * @param value - new boolean value for cache
     */
    onSwitch(value) {
        if (value === undefined) {
            return;
        }
        if (value) {
            this.activateIntegration();
        }
        else {
            this.deleteIntegration();
        }
    }
    /**
     * Save bot's customer service configuration
     */
    async saveConfiguration() {
        await this.ConfigurationsService.set(`${DESK_OWNER_IDENTITY}.${this.MESSAGINGHUBDOMAIN}`, this.configuration, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
    }
    /**
     * Register successful connection, with toast and segment events
     */
    registerSuccessfulConnection() {
        try {
            this.ToastService.toast(ToastType.Success, 'deskWebhookProvider.success.connection');
            this.SegmentService.createBotTrack('helpdesk-integrations-webhook-connected', this.application, { status: SUCCESS_STATUS });
            this.SegmentService.setAccount({ customerServiceChannel: Webhook });
        }
        catch (e) { } //Not necessary error handling
    }
    /**
     * Register failed connection, with toast and segment events
     */
    registerFailedConnection() {
        try {
            this.ToastService.toast(ToastType.Danger, 'deskWebhookProvider.error.connection');
            this.SegmentService.createBotTrack('helpdesk-integrations-Webhook-connected', this.application, { status: FAILURE_STATUS });
        }
        catch (e) { } //Not necessary error handling
    }
    /**
     * Register successful disconnection, with toast and segment events
     */
    registerSuccessfulDisconnection() {
        try {
            this.ToastService.toast(ToastType.Success, 'deskWebhookProvider.success.disconnection');
            this.SegmentService.createBotTrack('helpdesk-integrations-webhook-disabled', this.application, { status: SUCCESS_STATUS });
            this.SegmentService.setAccount({ customerServiceChannel: 'None' });
        }
        catch (e) { } //Not necessary error handling
    }
    /**
     * Register failed disconnection, with toast and segment events
     */
    registerFailedDisconnection() {
        try {
            this.ToastService.toast(ToastType.Danger, 'deskWebhookProvider.error.disconnection');
            this.SegmentService.createBotTrack('helpdesk-integrations-webhook-disabled', this.application, { status: FAILURE_STATUS });
        }
        catch (e) { } //Not necessary error handling
    }
    setFormUnpristine() {
        this.configurationForm.$pristine = false;
    }
}
WebhookController.$inject = ['application', 'LoadingService', 'ConfigurationsService', 'DeskConfigurationService', 'ToastService', 'SegmentService', 'MESSAGINGHUBDOMAIN'];
